<template>

    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" :class="showToggled ? 'toggled' : ''"
        id="accordionSidebar" :style="colorMenu()">

        <a class="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
            <div class="sidebar-brand-text mx-3">
                <LogoNegative formatting="logo-center" width="135px"></LogoNegative>
            </div>
        </a>
        <hr class="sidebar-divider my-0">
        <li class="nav-item active">
            <router-link class="nav-link" to="/" :class="route == '/' ? 'active' : ''">
                <i class="fas fa-fw fa-home"></i>
                <span>Início</span></router-link>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseRegistrations"
                aria-expanded="true" aria-controls="collapseRegistrations">
                <i class="fas fa-fw fa-plus"></i>
                <span>Cadastros</span>
            </a>
            <div id="collapseRegistrations" class="collapse collapse_menu" aria-labelledby="headingTwo"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'category' ? 'active' : ''" to="/category"
                        @click="itemSelectec('category')">Categorias</router-link>
                    <router-link class="collapse-item" :class="route == 'service' ? 'active' : ''" to="/service"
                        @click="itemSelectec('service')">Serviços</router-link>
                    <router-link class="collapse-item" :class="route == 'supplier' ? 'active' : ''" to="/supplier"
                        @click="itemSelectec('supplier')">Fornecedores</router-link>
                    <router-link class="collapse-item" :class="route == 'client' ? 'active' : ''" to="/client"
                        @click="itemSelectec('client')">Clientes</router-link>
                    <router-link class="collapse-item" :class="route == 'lead' ? 'active' : ''" to="/lead"
                        @click="itemSelectec('lead')">Leads</router-link>
                    <router-link class="collapse-item" :class="route == 'notification-client' ? 'active' : ''" to="/notification-client"
                        @click="itemSelectec('notification-client')">Notificações</router-link>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseFinancial"
                aria-expanded="true" aria-controls="collapseFinancial">
                <i class="fas fa-fw fa-money-bill"></i>
                <span>Financeiro</span>
            </a>
            <div id="collapseFinancial" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'bank-account' ? 'active' : ''"
                        to="/bank-account" @click="itemSelectec('bank-account')">Contas bancárias</router-link>
                    <router-link class="collapse-item" :class="route == 'receivable-account' ? 'active' : ''"
                        to="/receivable-account" @click="itemSelectec('receivable-account')">Receitas</router-link>
                    <router-link class="collapse-item" :class="route == 'payable-account' ? 'active' : ''"
                        to="/payable-account" @click="itemSelectec('payable-account')">Despesas</router-link>
                    <router-link class="collapse-item" :class="route == 'dashboard-financial' ? 'active' : ''"
                        to="/dashboard-financial" @click="itemSelectec('dashboard-financial')">Resumo
                        Financeiro</router-link>
                </div>
            </div>
        </li>
        <!--
        <hr class="sidebar-divider">
         <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseReport"
                aria-expanded="true" aria-controls="collapseReport">
                <i class="fas fa-fw fa-file-pdf"></i>
                <span>Relatórios</span>
            </a>
            <div id="collapseReport" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                     <router-link class="collapse-item" :class="route == 'bank-account' ? 'active' : ''" to="/bank-account"
                        @click="itemSelectec('bank-account')">Contas bancárias</router-link>
                    <a class="collapse-item" href="login.html">Contas a pagar</a>
                    <a class="collapse-item" href="register.html">Contas a receber</a>
                </div>
            </div>
        </li>   -->
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseActivity"
                aria-expanded="true" aria-controls="collapseActivity">
                <i class="fas fa-calendar"></i>
                <span>Atividades</span>
            </a>
            <div id="collapseActivity" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'activity' ? 'active' : ''" to="/activity"
                        @click="itemSelectec('activity')">Equipe</router-link>
                    <router-link class="collapse-item" :class="route == 'activity-statistic' ? 'active' : ''"
                        to="/activity-statistic" @click="itemSelectec('activity-statistic')">Estatísticas</router-link>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider" v-if="support == 'true'">
        <li class="nav-item active">
            <router-link class="nav-link" to="help-desk" :class="route == 'help-desk' ? 'active' : ''"
                v-if="support == 'true'">
                <i class="fa fa-ticket-alt" aria-hidden="true"></i>
                <span>Suporte</span></router-link>
        </li>
        <hr class="sidebar-divider" v-if="event == 'true'">
        <li class="nav-item" v-if="event == 'true'">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseAutomation"
                aria-expanded="true" aria-controls="collapseAutomation">
                <i class="fas fa-robot"></i>
                <span>Automatização</span>
            </a>
            <div id="collapseAutomation" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'event' ? 'active' : ''" to="/event"
                        @click="itemSelectec('event')">Eventos</router-link>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider" v-if="whatsapp == 'true'">
        <li class="nav-item" v-if="whatsapp == 'true'">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseWhatsapp"
                aria-expanded="true" aria-controls="collapseWhatsapp">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-whatsapp" viewBox="0 0 16 16">
                    <path
                        d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                </svg>
                <span>Whatsapp</span>
            </a>
            <div id="collapseWhatsapp" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'whatsapp' ? 'active' : ''" to="/whatsapp"
                        @click="itemSelectec('whatsapp')">Conversas</router-link>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseConfig"
                aria-expanded="true" aria-controls="collapseConfig">
                <i class="fas fa-fw fa-cog"></i>
                <span>Configurações</span>
            </a>
            <div id="collapseConfig" class="collapse collapse_menu" aria-labelledby="headingPages"
                data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">
                    <router-link class="collapse-item" :class="route == 'user' ? 'active' : ''" to="/user"
                        @click="itemSelectec('user')">Usuários</router-link>
                    <router-link class="collapse-item" :class="route == 'role' ? 'active' : ''" to="/role"
                        @click="itemSelectec('role')">Perfil de acesso</router-link>
                    <router-link class="collapse-item" :class="route == 'mirror-directory' ? 'active' : ''"
                        to="/mirror-directory" @click="itemSelectec('mirror-directory')">Diretórios
                        espelho</router-link>
                    <router-link class="collapse-item" :class="route == 'general-configuration' ? 'active' : ''"
                        to="/general-configuration" @click="itemSelectec('general-configuration')">Geral</router-link>
                    <router-link class="collapse-item" :class="route == 'log' ? 'active' : ''" to="/log"
                        @click="itemSelectec('log')">Logs</router-link>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider">
        <li class="nav-item">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseProfile"
                aria-expanded="true" aria-controls="collapseProfile">
                <i class="fas fa-fw fa-user"></i>
                <span>Perfil</span>
            </a>
            <div id="collapseProfile" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
                <div class="bg-white py-2 collapse-inner rounded">

                    <a class="collapse-item" href="#" @click="logout()">Sair</a>
                </div>
            </div>
        </li>
        <hr class="sidebar-divider d-none d-md-block">

        <div class="text-center d-none d-md-inline">
            <button class="rounded-circle border-0" id="sidebarToggle" @click="showHideMenu"></button>
        </div>
    </ul>
</template>

<script>
import api from '@/api';
import LogoNegative from '../img/logo-negative.vue';
import { menu } from '../../menu.js'

export default {
    components: { LogoNegative },
    data() {
        return {
            toggled: true,
            support: false,
            event: false,
            whatsapp: false,
            route: ''
        }
    },

    computed: {
        showToggled: function () {
            return !menu.toggled;
        }
    },

    mounted() {
        this.toggled = !menu.toggled;
        this.support = process.env.VUE_APP_SUPPORT;
        this.event = process.env.VUE_APP_EVENT;
        this.whatsapp = process.env.VUE_APP_WHATSAPP;
    },

    methods: {
        colorMenu() {

            const color = process.env.VUE_APP_COLOR_MENU;
            if (color == undefined || color == '') {
                return 'background-color: #D99896';
            }

            return 'background-color: ' + color;
        },
        itemSelectec(item) {
            this.route = item;
            const collapse = document.querySelectorAll('.collapse_menu');
            collapse.forEach(div => {
                div.className = "";
                div.className = "collapse collapse_menu";
            });
        },
        showHideMenu() {
            menu.changeToggled();
        },
        logout() {
            api.post('/auth/logout')
                .then(() => {
                    this.$notify({
                        title: "Sucesso",
                        text: "Sessão encerrada com sucesso!",
                        type: 'success'
                    });
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    localStorage.removeItem('email');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    localStorage.removeItem('expire_in');
                    localStorage.removeItem('change_password');
                    localStorage.removeItem('two_authentication_factor');
                    localStorage.removeItem('user_id');
                    localStorage.removeItem('term_use');
                    localStorage.removeItem('text_term_use');

                    this.$router.push('/login');
                }).catch(error => {
                    if (error.status == 401) {
                        this.$notify({
                            title: "Falha",
                            text: "Sessão já encerrada!",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    } else if (error.status == 429) {
                        this.$notify({
                            title: "Falha",
                            text: "Foram realizadas várias tentativas de finalização de sessão! Aguarde alguns instantes e tente novamente!",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    } else if (error.status == 500) {
                        this.$notify({
                            title: "Falha",
                            text: "Não foi possível encerrar a sessão! Por gentileza, contacte o suporte técnico para mais detalhes",
                            type: 'error'
                        });
                        this.$router.push('/login');
                    }

                })
        },
    }
}
</script>

<style>
.active {
    font-weight: bold;
}
</style>